import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trigger", "form", "input"];

  showForm() {
    this.triggerTarget.classList.add("d-none");
    this.formTarget.classList.remove("d-none");
    this.inputTarget.focus();
  }

  hideForm() {
    this.formTarget.classList.add("d-none");
    this.triggerTarget.classList.remove("d-none");
    this.inputTarget.value = "";
  }
}
